<template>
  <div style="text-align: left; font-size: 0.24rem">
    <ul class="enable-list-type">
      <li>
        首次存款需达到最低存款金额，否则无法激活账户进行交易，当前账户最低存款金额是${{ minDepositAmt }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'Usdt3Alert',
  props: {
    minDepositAmt: {
      type: Number,
      default: 0
    }
  }
}
</script>
